import React, { FormEvent, useEffect } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

// helper
import { deleteReservation, getReservation, updateReservationStep1 } from '../helpers/localStorage';
import { Ireservation } from '../helpers/interfaces';

import { fetchRequest } from '../helpers/fetcher';
import { ToastPosition } from 'react-toastify/dist/types';

export function step4Loader() {
  return getReservation();
}

interface Props { }

const Step4page: React.FC<Props> = () => {

  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const savedReservation = useLoaderData() as Ireservation;

  useEffect(() => {
    if (!savedReservation.people && !savedReservation.date) navigate("/");
  }, [savedReservation, navigate]);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {

      const apiUrl = process.env.REACT_APP_API_FULL_URL;
      const url = apiUrl + '/customer/reservations';
      await fetchRequest(
        url,
        "POST",
        "Non è stato possibile effettuare la richiesta. Riprova più tardi.",
        JSON.stringify(
          { 
            ...savedReservation, 
            date: moment(savedReservation.date).format('YYYY-MM-DD'),
            menu: savedReservation.menu === 'null' ? null : savedReservation.menu
          }
        ),
      );
      deleteReservation();

      if(savedReservation.status === 'waiting') return window.location.href = "https://www.miramontilaltro.it/lista-d-attesa/";
      else window.location.href = "https://www.miramontilaltro.it/contatti-ok/";
    
    } catch (error) {
      if (error instanceof Error) {
        if (!error.cause) return window.alert(error.message);

        const toastOptions = {
          autoClose: 10 * 1000,
          pauseOnFocusLoss: false,
          theme: "colored",
          position: 'bottom-center' as ToastPosition,
          onClose: () => navigate("/"),
        };

        switch (error.cause) {

          case 101:
            updateReservationStep1({ ...savedReservation, date: undefined, service: undefined, slot: undefined });
            toast.error(
              <div>
                <p>Non è più possibile prenotare per {moment(savedReservation.date).format("D MMMM")} a {savedReservation.service === 'lunch' ? 'pranzo' : 'cena'}.</p>
                <p>Scegliere una nuova soluzione dal <strong>calendario</strong></p>
              </div>, toastOptions);
            return;

          case 500:
            updateReservationStep1({ ...savedReservation, date: undefined, service: undefined, slot: undefined });
            toast.error(
              <div>
                <p>Il ristorante è stato chiuso per il {moment(savedReservation.date).format("D MMMM")} a {savedReservation.service === 'lunch' ? 'pranzo' : 'cena'}.</p>
                <p>Scegliere una nuova soluzione dal <strong>calendario</strong></p>
              </div>
              , toastOptions);
            return;

          case 501:
            updateReservationStep1({ ...savedReservation, date: undefined, service: undefined, slot: undefined });
            toast.error(
              <div>
                <p>Il ristorante è al completo per il {moment(savedReservation.date).format("D MMMM")} a {savedReservation.service === 'lunch' ? 'pranzo' : 'cena'} per {savedReservation.people} {savedReservation.people === 1 ? 'persona' : 'persone'}.</p>
                <p>Scegliere una nuova soluzione dal <strong>calendario</strong> o merttersi in <strong>lista d'attesa</strong></p>
              </div>
              , toastOptions);
            return;

          default:
            toast.error(`Errore non gestito ${error.cause} - ${error.message}`);
            throw new Error(`Errore non gestito ${error.cause} - ${error.message}`);
        }
      }
      setIsSubmitting(false);
      throw error;
    } finally {
      // setIsSubmitting(false);
    }
  };

  return (
    <div className="customer-data">

      <h2>Step 4 - Riepilogo</h2>

      <form onSubmit={onSubmit}>

        {/* <input type="hidden" name="_action" value="step4" /> */}

        <div className='recap'>

          <p className='type'><span className="header">Tipo:</span>
            <span className="content">{savedReservation.status === 'waiting' ? "Lista d'attesa" : 'Richiesta di prenotazione'}</span>
          </p>
          <p className='date'>
            <span className="header">Data:</span>
            <span className="content">{moment(savedReservation.date).format('dddd D MMMM')}</span>
          </p>
          <p className='service-slot'>
            <span className="header">Servizio:</span>
            <span className="content">{savedReservation.service === 'lunch' ? 'pranzo' : 'cena'} {savedReservation.slot ? ' alle ' + savedReservation.slot : ''}
            </span>
          </p>
          <p className='people'>
            <span className="header">Numero di persone:</span>
            <span className="content">{savedReservation.people}</span>
          </p>

          <div className='customer'>
            <p className='name'>
              <span className="header">Nominativo:</span>
              <span className="content">{savedReservation.firstName} {savedReservation.lastName}</span>
            </p>
            <p className='phone'>
              <span className="header">Telefono:</span>
              <span className="content">{savedReservation.phone}</span>
            </p>
            <p className='email'>
              <span className="header">Email:</span>
              <span className="content">{savedReservation.email}</span>
            </p>
            <p className='allergies'>
              <span className="header">Allergie:</span>
              <span className="content">{(savedReservation.allergies ?? []).join(', ')}</span>
            </p>
            <p className='note'>
              <span className="header">Note: </span>
              <span className="content">{savedReservation.note ?? ''}</span>
            </p>
            <p className='menu'>
              <span className="header">Menù:</span>
              <span className="content">{savedReservation.menu ?? '' }</span>
            </p>
          </div>

          <div className="agreements">

            {/* <p className='gdpr'>
              <span className="header">G.D.P.R.:</span>
              <span className="content">{savedReservation.gdpr ? 'Sì' : 'No'}</span>
            </p> */}

            <p className='mailing-list'>
              <span className="header">News letter:</span>
              <span className="content">{savedReservation.mailingList ? 'Sì' : 'No'}</span>
            </p>

          </div>

        </div>

        {<button type="submit" className="btn btn--dark" disabled={isSubmitting}>
          {isSubmitting ? (
            <span>Salvando...</span>
          ) : (
            <>
              <span>{savedReservation.status === 'pending' ? 'Invia richiesta di prenotazione' : 'Inserisci in lista d\'attesa'}</span>
              {/* <CurrencyEuroIcon width={20} /> */}
            </>
          )}
        </button>}

      </form>

      {/* <pre>{JSON.stringify(savedReservation, null, 2)}</pre> */}

    </div>
  )
}
export default Step4page;